import { SVGProps } from 'react';
import { SvgSymbolIds } from '../constants';
export function IconTick(props: SVGProps<SVGSVGElement>) {
  return <svg {...props} data-sentry-element="svg" data-sentry-component="IconTick" data-sentry-source-file="tick.tsx">
            <use href={`#${SvgSymbolIds.Tick}`} data-sentry-element="use" data-sentry-source-file="tick.tsx" />
        </svg>;
}